import { Module, ActionContext } from 'vuex'
import { RootState, TwilioAccountState } from './state_models'
import { TwilioAccount } from '../models'

export const twilioAccount: Module<TwilioAccountState, RootState> = {
  namespaced: true,
  state: { twilioAccount: [], locationId: undefined as any } as TwilioAccountState,
  mutations: {
    setTwilioAccount (state, { twilioAccount, locationId}) {
      state.twilioAccount = twilioAccount
      state.locationId = locationId
    },
    clearAll(state) {
      state.twilioAccount = [];
      state.locationId = undefined as any
    }
  },
  getters: {
    isLocationUnderLCPhone: (state: TwilioAccountState) => {
      return state.twilioAccount.length > 0 ? state.twilioAccount[0].under_ghl_account : false
    },
    getTwilioAccount: (state: TwilioAccountState) => {
      return state.twilioAccount
    }
  },
  actions: {
    async getByLocationId(
      context: ActionContext<TwilioAccountState, RootState>,
      params: { locationId: string }
    ) {

      if(!params || !params.locationId) {
        return []
      }

      const locationId = params.locationId;
      if (context.state.locationId === locationId) {
        return context.state.twilioAccount
      }

      const locationTwilio = await TwilioAccount.getByLocationId(locationId)
      if (locationTwilio) {
        context.commit('setTwilioAccount', { twilioAccount: { id: locationTwilio?.id, ...locationTwilio?.data } , locationId });
        return locationTwilio?.data
      }

      return []
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<TwilioAccountState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<TwilioAccountState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
